<template>
  <app-layout>
    <app-header>
      <icon-link
        :href="route('home')"
        icon="arrow-thin-left-circle"
        class="icons-secondary"
      >
        Back to dashboard
      </icon-link>
      <h1>
        <small
          v-if="competitionPublishDate"
          class="font-normal text-xs opacity-50 leading-none block"
        >
          {{ competitionPublishDate }}
        </small>
        {{ state.competition.title }} Competition
        <icon-link
          class="ml-5"
          icon="edit-circle"
          :href="
            route('funding.competitions.index', {
              funding: state.competition.funding_pots[0].id,
              competition: state.competition.uuid
            })
          "
        >
          Edit Competition
        </icon-link>
      </h1>
    </app-header>
    <competition-applications-assessors :state="state" />
  </app-layout>
</template>

<script>
import format from "date-fns/format";
import parseISO from "date-fns/parseISO";
export default {
  name: "CompetitionApplications",
  data() {
    return {
      active: "all"
    };
  },
  computed: {
    competitionPublishDate() {
      if (!this.state.competition.published_at) return;
      return format(
        parseISO(this.state.competition.published_at),
        "do MMMM yyyy"
      );
    }
  },
  created() {
    this.loadTabWithHash(window.location.hash);
    document.title = `Competition Applications :: ${document.title}`;
  },
  methods: {
    loadTabWithHash(hash) {
      if (!hash) return;
      hash = hash.replace("#", "");
      return this.setActive(hash);
    },
    setActive(index) {
      window.location.hash = this.tabs[index] ? this.tabs[index].hash : index;
      this.scrollTop();
      this.saveApplication;
      this.active = index;
    }
  }
};
</script>
